import { Button, Empty, Form, message, Modal, Spin } from 'antd';
import { useExcepcion, useUpdateExcepcion } from '../api/useExcepciones';
import { useT } from '../../../locales';
import { ExcepcionForm } from './ExcepcionForm';

interface ExcepcionEditModalProps {
  id: number | null;
  onClose: () => void;
  onSuccess?: () => void;
}

export function ExcepcionEditModal({ id, onClose, onSuccess }: ExcepcionEditModalProps) {
  const t = useT();
  const [form] = Form.useForm();
  const { data: excepcion, isLoading, error } = useExcepcion(id ?? 0);
  const updateExcepcion = useUpdateExcepcion();

  const handleSubmit = async (values: Record<string, unknown>) => {
    if (!excepcion) return;
    try {
      await updateExcepcion.mutateAsync({ id: excepcion.id, dto: values });
      message.success(t('pages.excepciones.editSuccess'));
      onClose();
      onSuccess?.();
    } catch {
      message.error(t('pages.excepciones.editError'));
    }
  };

  return (
    <Modal
      title={t('pages.excepciones.edit')}
      open={id !== null}
      onCancel={onClose}
      destroyOnHidden
      centered
      width={640}
      rootClassName="excepcion-edit-modal"
      styles={{ body: { maxHeight: 'min(75vh, 675px)', overflowY: 'auto' } }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('common.cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={updateExcepcion.isPending}
          onClick={() => form.submit()}
        >
          {t('common.saveChanges')}
        </Button>,
      ]}
    >
      {isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
          <Spin size="large" />
        </div>
      ) : error || !excepcion ? (
        <Empty
          description={
            <div>
              <div>{t('pages.excepciones.notFound')}</div>
              <div style={{ fontSize: 13 }}>{t('pages.excepciones.notFoundDetail')}</div>
            </div>
          }
        />
      ) : (
        <ExcepcionForm
          mode="edit"
          form={form}
          hideSubmit
          initialValues={excepcion}
          onSubmit={handleSubmit}
          loading={updateExcepcion.isPending}
        />
      )}
    </Modal>
  );
}
